import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Label,
  Button,
  CardHeader,
  Collapse,
  FormFeedback,
  Input,
  UncontrolledTooltip,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
  Media,
} from "reactstrap"
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import SimpleBar from "simplebar-react"
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../components/Common/LoadingModal";
import {
  setSuccess as onSetSuccess,
  setContacsDetailResult as onSetContacsDetailResult,
  getContactsDetails as onGetContactsDetails,
  changeContactsDetails as onChangeContactsDetails,
  getImportedContacts as onGetImportedContacts,
  getSuggestedContacts as onGetSuggestedContacts,
  getContactsMemo as onGetContactsMemo,
  saveMemo as onSaveMemo,
  changeImportedContacts as onChangeImportedContacts,
  changeSuggestedContacts as onChangeSuggestedContacts,
  changeMemberConfirmedContacts as onChangeMemberConfirmedContacts,
  multipleStarContacts as onMultipleStarContacts,
  multipleUnstarContacts as onMultipleUnstarContacts,
  multipleHideContacts as onMultipleHideContacts,
  multipleUnhideContacts as onMultipleUnhideContacts,
  multipleUnsubscribeContacts as onMultipleUnsubscribeContacts,
  checkEmailUnsubscribe as onCheckEmailUnsubscribe,
  saveContacts as onSaveContacts,
  saveContactsSimple as onSaveContactsSimple,
  deleteContacts as onDeleteContacts,
  // getDomainCorrectYnCount as onGetDomainCorrectYnCount,
  saveDomainCorrectYn as onSaveDomainCorrectYn,
  changeUserSuggestDomain as onChangeUserSuggestDomain,
  changeShowSuccessAddToastFlag as onChangeShowSuccessAddToastFlag,
  changeCheckUnsubsEmailAddressFlag as onChangeCheckUnsubsEmailAddressFlag,
  disableContactSendYn,
  enableContactSendYn,
  setSuggestedContactsActive,
  setSuggestedContactsTotalPage,
  getAllCountryList as onGetAllCountryList,
} from "../../store/actions";
import { cloneDeep } from 'lodash';
import classnames from "classnames"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import Select from "react-select";


const httpDomains = [
  "nacakci.com",
]

const ViewDetail = props => {
  // console.log(">>> [contacts] props : "+JSON.stringify(props));
  const dispatch = useDispatch();

  const { contactsDetails, importedContacts, importedTotalPage, suggestedContacts, suggestedContactsActive, suggestedTotalPage, suggestedContactsExist, memo, loading, success, detailResult, domainCorrectYnCount, userSuggestDomain, showSuccessAddToastFlag, unsubsEmailAddress1, unsubsEmailAddress2, checkUnsubsEmailAddressFlag, toastMessage, saveType, screenName, memberConfirmedContacts } = useSelector(state => ({
    contactsDetails: state.Contacts.contactsDetails,
    importedContacts: state.Contacts.importedContacts,
    importedTotalPage: state.Contacts.importedTotalPage,
    suggestedContacts: state.Contacts.suggestedContacts,
    suggestedContactsActive: state.Contacts.suggestedContactsActive,
    suggestedTotalPage: state.Contacts.suggestedTotalPage,
    suggestedContactsExist: state.Contacts.suggestedContactsExist,
    memo: state.Contacts.memo,
    loading: state.Contacts.loading,
    success: state.FilerRankings.success,
    detailResult: state.Contacts.detailResult,
    domainCorrectYnCount: state.Contacts.domainCorrectYnCount,
    userSuggestDomain: state.Contacts.userSuggestDomain,
    showSuccessAddToastFlag: state.Contacts.showSuccessAddToastFlag,
    unsubsEmailAddress1: state.Contacts.unsubsEmailAddress1,
    unsubsEmailAddress2: state.Contacts.unsubsEmailAddress2,
    checkUnsubsEmailAddressFlag: state.Contacts.checkUnsubsEmailAddressFlag,
    toastMessage: state.Contacts.toastMessage,
    saveType: state.Contacts.saveType,
    screenName: state.Contacts.screenName,
    memberConfirmedContacts: state.Contacts.memberConfirmedContacts,
  }));

  const { countryList } = useSelector(state => ({
    countryList: state.GeneralStatistics.countryList,
  }));

  const targetGroupNo = props.targetGroupNo != undefined ? props.targetGroupNo : props.match.params.targetGroupNo;
  const targetGroupCountry = props.targetGroupCountry != undefined ? props.targetGroupCountry : props?.match?.params?.targetGroupCountry;
  const targetGroupAddress = props.targetGroupAddress != undefined ? props.targetGroupAddress : props?.match?.params?.targetGroupAddress;
  const field = props.field != undefined ? props.field : props?.match?.params?.field;
  const pctRepList = props.pctRepList != undefined ? props.pctRepList : null;
  // console.log(">>> [contacts] targetGroupNo : ", targetGroupNo);
  // console.log(">>> [contacts] targetGroupCountry : ", targetGroupCountry);
  // console.log(">>> [contacts] targetGroupAddress : ", targetGroupAddress);
  // console.log(">>> [contacts] field : ", field);
  // console.log(">>> [contacts] pctRepList : ", pctRepList);

  const [importedContactsOpen, setImportedContactsOpen] = useState(true);
  const importedToggle = () => setImportedContactsOpen(!importedContactsOpen);
  const [suggestedContactsOpen, setSuggestedContactsOpen] = useState(true);
  const suggestedToggle = () => setSuggestedContactsOpen(!suggestedContactsOpen);

  const [confirmMsg, setConfirmMsg] = useState("");
  const [confirmAlert, setConfirmAlert] = useState(false);

  const [chkAll, setChkAll] = useState(false);
  const [chkAll2, setChkAll2] = useState(false);
  const [chkAllMemberConfirmedContacts, setChkAllMemberConfirmedContacts] = useState(false);
  const [importedChkAll, setImportedChkAll] = useState(false);

  const [domainSuggestAlert, setDomainSuggestAlert] = useState(false);
  const [requireDomainAlert, setRequireDomainAlert] = useState(false);

  const [keyword, setKeyword] = useState("");
  const [curPageUp, setCurPageUp] = useState(1);
  const [curPageInput, setCurPageInput] = useState(1);

  const [suggestedKeyword, setSuggestedKeyword] = useState("");
  const [suggestedCurPage, setSuggestedCurPage] = useState(1);
  const [suggestedCurPageInput, setSuggestedCurPageInput] = useState(1);
  const [sendableEmailFlag, setSendableEmailFlag] = useState(true);
  const [sendableHagueEmailFlag, setSendableHagueEmailFlag] = useState(true);
  const [sendableFilerEmailFlag, setSendableFilerEmailFlag] = useState(true);
  const [sendablePctEmailFlag, setSendablePctEmailFlag] = useState(true);
  const [enableOrDisable, setEnableOrDisable] = useState("Disable");


  /**
   * errMsg[0] : .csv 파일이 아님
   * errMsg[1] : 선택된 entity 없음.
   * errMsg[2] : 선택된 contact 없음.
   * errMsg[3] : save되지 않은 contact 선택함.
   * errMsg[4] : 필수항목 미입력
   * errMsg[5] : email 형식 잘못됨
   * errMsg[6] : 필수항목 미입력
   */
  const errMsg = [
    "not csv file"
    , "Please select a entity."
    , "Please select a contact."
    , "There are unsaved rows."
    , "Email address is required."
    , <>Invalid email format: Please check if you accidentally included any special characters or blank spaces.
      <br /><br />Please refer to the following websites to check for any hidden special characters or blank spaces:
      <br /> <a href='https://www.regextester.com/99810' target='_blank'>https://www.regextester.com/99810</a>,
      <br /> <a href='https://freetools.textmagic.com/unicode-detector' target='_blank'>https://freetools.textmagic.com/unicode-detector</a>
      <br />*Please note that we do not have any affiliation with these websites, but we found them helpful.</>
    , "First name is required."
    , "Please select email address!"
    , "This domain is verified!"
    , "This email address already exists for this entity!"
    , "The following email addresses have already been unsubscribed:"
    , "You can save up to 3 contacts for each tool."
    , "The following email addresses contain unsubscribed domains:"
  ];

  const [dupeEmailAddress, setDupeEmailAddress] = useState([]);
  const [addSimpleAdressList, setAddSimpleAdressList] = useState([]);

  const [activeTab, setactiveTab] = useState("Contacts")
  const [lastContactCheckedIdx, setLastContactCheckedIdx] = useState(-1);
  function toggleActiveTab(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
    setLastContactCheckedIdx(-1);
  }

  useEffect(() => {
    // dispatch(onGetImportedContacts({perPage: 10, curPage: curPageUp}));
    // dispatch(onGetSuggestedContacts({targetGroupNo : targetGroupNo}));
    dispatch(onGetContactsDetails({ targetGroupNo: targetGroupNo, targetGroupCountry: targetGroupCountry, targetGroupAddress: targetGroupAddress, field: field, tool: field=="Patent" ? "PCTN" : "" }));
    // dispatch(onGetContactsMemo({targetGroupNo : targetGroupNo}));
    // dispatch(onGetDomainCorrectYnCount({targetGroupNo : targetGroupNo}));
  }, [targetGroupNo, targetGroupCountry, targetGroupAddress, field]);

  useEffect(() => {
    if (showSuccessAddToastFlag) {
      showSuccessAddToast();
      dispatch(onChangeShowSuccessAddToastFlag(false));
    }
  }, [showSuccessAddToastFlag]);

  useEffect(() => {
    if (contactsDetails && Object.keys(contactsDetails).length !== 0) {
      let dontSendEmailCnt = 0;
      let dontSendHagueEmailCnt = 0;
      let dontSendFilerEmailCnt = 0;
      let dontSendPctEmailCnt = 0;
      contactsDetails.contactsList.map((contact, contactIdx) => {
        if (contact.unsubscribe === "Y" || contact.sendYn === "N") {
          dontSendEmailCnt++;
        }
        if (contact.unsubscribe === "Y" || contact.hagueSendYn === "N") {
          dontSendHagueEmailCnt++;
        }
        if (contact.unsubscribe === "Y" || contact.filerSendYn === "N") {
          dontSendFilerEmailCnt++;
        }
        if (contact.unsubscribe === "Y" || contact.pctSendYn === "N") {
          dontSendPctEmailCnt++;
        }

      })

      if (dontSendEmailCnt == contactsDetails.contactsList.length) {
        setSendableEmailFlag(false);
      } else {
        setSendableEmailFlag(true);
      }

      if (dontSendHagueEmailCnt == contactsDetails.contactsList.length) {
        setSendableHagueEmailFlag(false);
      } else {
        setSendableHagueEmailFlag(true);
      }

      if (dontSendFilerEmailCnt == contactsDetails.contactsList.length) {
        setSendableFilerEmailFlag(false);
      } else {
        setSendableFilerEmailFlag(true);
      }

      if (dontSendPctEmailCnt == contactsDetails.contactsList.length) {
        setSendablePctEmailFlag(false);
      } else {
        setSendablePctEmailFlag(true);
      }
    }
  }, [contactsDetails]);

  useEffect(() => {
    if (checkUnsubsEmailAddressFlag && screenName == 'Detail') {
      dispatch(onChangeCheckUnsubsEmailAddressFlag(false));
      if (saveType == 'INPUT') {
        validation.setFieldValue("submitType", "Save");
        setConfirmMsg("Are you sure you want to save the selected email(s)?");
        setConfirmAlert(true);
      } else {
        // console.log("hello: ", addSimpleAdressList)
        dispatch(onSaveContactsSimple(addSimpleAdressList));
        // setAddSimpleAdressList([]);
      }
    }
  }, [checkUnsubsEmailAddressFlag]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      submitType: "",
      textarea: memo && memo.memo ? memo.memo : "",
    },
    onSubmit: (values) => {
      // console.log(JSON.stringify(values, null, 2));
      // console.log("targetGroupNo : "+targetGroupNo);
      let submitType = values["submitType"];

      if (submitType == "memo") {
        const param = {
          targetGroupNo: targetGroupNo,
          memo: values["textarea"],
        };
        dispatch(onSaveMemo(param));
      } else if (submitType == "Star") {
        let _contactsDetails = cloneDeep(contactsDetails);
        _contactsDetails.starred = true;

        dispatch(onMultipleStarContacts([_contactsDetails], null));
      } else if (submitType == "Unstar") {
        let _contactsDetails = cloneDeep(contactsDetails);
        _contactsDetails.starred = false;

        dispatch(onMultipleUnstarContacts([_contactsDetails], null));
      } else if (submitType == "Hide") {
        let _contactsDetails = cloneDeep(contactsDetails);
        _contactsDetails.hidden = true;

        dispatch(onMultipleHideContacts([_contactsDetails], null));
      } else if (submitType == "Unhide") {
        let _contactsDetails = cloneDeep(contactsDetails);
        _contactsDetails.hidden = false;

        dispatch(onMultipleUnhideContacts([_contactsDetails], null));
      } else if (submitType.indexOf("Unsubscribed_") === 0
        || submitType.indexOf("Confirmed_") === 0) {
        let emailSeq = submitType.substring(submitType.lastIndexOf("_") + 1, submitType.length);
        let value = submitType.indexOf("Unsubscribed_") === 0 ? "Y" : "N"
        let _contactsDetails = cloneDeep(contactsDetails);
        _contactsDetails.contactsList = _contactsDetails.contactsList.map((contact, idx) => {
          if (contact.emailSeq == emailSeq) {
            contact.unsubscribe = value;
          }

          return contact;
        });

        dispatch(onMultipleUnsubscribeContacts(_contactsDetails.contactsList, null));
      } else if (submitType == "Save" || submitType == "Delete") {
        const _contactsList = [];
        contactsDetails.contactsList.map((contact, contactIdx) => {
          if (contact.checked) _contactsList.push(contact);
        });

        if (submitType == "Save") dispatch(onSaveContacts(_contactsList, null));
        else if (submitType == "Delete") dispatch(onDeleteContacts(_contactsList, null));

      } else if (submitType == "Unsubscribed" || submitType == "Confirmed") {
        let value = submitType == "Unsubscribed" ? "Y" : "N"
        let _contactsDetails = cloneDeep(contactsDetails);
        const _contactsList = [];
        _contactsDetails.contactsList.map((contact, contactIdx) => {
          if (contact.checked) {
            contact.unsubscribe = value;
            _contactsList.push(contact);
          }
        });

        dispatch(onMultipleUnsubscribeContacts(_contactsList, null));
      } else if (submitType == 'Disable') {
        let _contactsDetails = cloneDeep(contactsDetails);
        const _contactsList = [];
        _contactsDetails.contactsList.map((contact, idx) => {
          if (contact.checked && contact.unsubscribe !== 'Y' && contact.unsubscribe !== "D") {
            _contactsList.push(contact);
          }
        });
        // console.log("submit_type disable")
        dispatch(disableContactSendYn(_contactsList, null));
      } else if (submitType == 'Enable') {
        let _contactsDetails = cloneDeep(contactsDetails);
        const _contactsList = [];
        _contactsDetails.contactsList.map((contact, idx) => {
          if (contact.checked && contact.unsubscribe !== 'Y' && contact.unsubscribe !== "D") {
            _contactsList.push(contact);
          }
        });
        if (checkContactListLimit(contactsDetails.contactsList, [], 'enable') == false) {
          //console.log('contactsDetails.contactsList.length : ' + contactsDetails.contactsList.length)
          dispatch(onSetContacsDetailResult(11));
        } else {
          dispatch(enableContactSendYn(_contactsList, null));
        }
      }
    },
  });

  const contactCheck = (contactChkIdx, e) => {
    let _contactsDetails = cloneDeep(contactsDetails);
    let contactChkCnt = 0;
    let disableContactCnt = 0;
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    _contactsDetails.contactsList = _contactsDetails.contactsList.map((contact, contactIdx) => {
      if (contactChkIdx == "chkAll") {
        contact.checked = value;
      } else if (shift && ctrlOrCmd && lastContactCheckedIdx != -1) {
        const start = Math.min(contactChkIdx, lastContactCheckedIdx);
        const end = Math.max(contactChkIdx, lastContactCheckedIdx);
        if (contactIdx >= start && contactIdx <= end) {
          contact.checked = value;
        }
      } else if (contactChkIdx == contactIdx) {
        contact.checked = value;
      }
      if (contact.checked == true) {
        contactChkCnt++;
        if (contact.sendYn === 'N' && contact.hagueSendYn === 'N' && contact.filerSendYn === 'N' && contact.pctSendYn === 'N') {
          disableContactCnt++;
        }
      }
      return contact;
    })
    if (contactChkCnt === contactsDetails.contactsList.length) {
      _contactsDetails.checked = true;
    } else {
      _contactsDetails.checked = false;
    }

    if (contactChkCnt !== 0 && contactChkCnt === disableContactCnt) {
      setEnableOrDisable("Enable");
    } else {
      setEnableOrDisable("Disable");
    }
    if (contactChkIdx != "chkAll") setLastContactCheckedIdx(contactChkIdx);
    else setLastContactCheckedIdx(-1);

    dispatch(onChangeContactsDetails(_contactsDetails));
  }

  const handleTypeSelect = (contactIdx, value) => {
    let _contactsDetails = cloneDeep(contactsDetails);
    _contactsDetails.contactsList[contactIdx].type = value;

    dispatch(onChangeContactsDetails(_contactsDetails));
  }

  const handleInput = (attr, contactIdx, value) => {
    // console.log(attr, contactIdx, value)
    let _contactsDetails = cloneDeep(contactsDetails);
    _contactsDetails.contactsList[contactIdx][attr] = value;
    // console.log(_contactsDetails.contactsList)

    dispatch(onChangeContactsDetails(_contactsDetails));
  }

  const addContacts = () => {
    let _contactsDetails = cloneDeep(contactsDetails);
    let newRow = { "targetGroupNo": targetGroupNo, "emailSeq": null, "emailAddress": null, "modFlag": "I", "type": "To", "firstName": null, "lastName": null, "title": null, "position": null, "country": "", "office": "", "unsubscribe": "N", "checked": true, "sendYn": "Y", "hagueSendYn": "Y", "filerSendYn": "Y", "pctSendYn": "Y" };
    _contactsDetails.contactsList.push(newRow);

    dispatch(onChangeContactsDetails(_contactsDetails));
  }

  const searchImportedContacts = (keywordValue) => {
    let chkCnt = 0;
    let showCnt = 0;

    keywordValue = keywordValue.toLowerCase();
    setKeyword(keywordValue);
    setCurPageUp(1);
    setChkAll(false);
    /*
    let _importedContacts = cloneDeep(importedContacts);
    _importedContacts = _importedContacts.map((contact, idx) =>{
        if(contact.emailAddress.toLowerCase().includes(keyword) == true 
          || (contact.firstName && contact.firstName.toLowerCase().includes(keyword) == true)
            || (contact.lastName && contact.lastName.toLowerCase().includes(keyword) == true)
              || (contact.title && contact.title.toLowerCase().includes(keyword) == true)
                || (contact.position && contact.position.toLowerCase().includes(keyword) == true)){
          contact.show = true;
        }else{
          contact.show = false;
        }

        if(contact.show){
          showCnt++;
          if(contact.checked) chkCnt++;
        } 

        return contact;
    }); 

    if(showCnt === chkCnt){
      setChkAll(true);
    }else{
      setChkAll(false);
    }
    */

    dispatch(onGetImportedContacts({ keyword: keywordValue, perPage: 10, curPage: 1 }));
  }

  const viewContactsListUp = (curPageUp) => {
    // console.log("viewContactsListUp 1 [curPageUp: "+curPageUp);

    //curPage 유효성 체크
    if (curPageUp) {
      if (curPageUp > importedTotalPage) {
        curPageUp = importedTotalPage;
      } else if (curPageUp <= 0) {
        curPageUp = 1;
      }
    }

    setCurPageUp(curPageUp);
    setCurPageInput(curPageUp);
    setChkAll(false);

    // filterValidation.setValues(_values);
    // filterValidation.handleSubmit(filterValidation.values);

    dispatch(onGetImportedContacts({ keyword: keyword, perPage: 10, curPage: curPageUp }));
  }

  const searchSuggestedContacts = (keywordValue) => {
    keywordValue = keywordValue.toLowerCase();
    setSuggestedKeyword(keywordValue);
    setSuggestedCurPage(1);
    setSuggestedCurPageInput(1);
    setChkAll2(false);

    const suggestedContactsFiltered = suggestedContacts.filter(contact => {
      return contact.emailAddress.toLowerCase().includes(keywordValue) ||
        contact.firstName?.toLowerCase().includes(keywordValue) ||
        contact.lastName?.toLowerCase().includes(keywordValue) ||
        contact.position?.toLowerCase().includes(keywordValue) ||
        contact.title?.toLowerCase().includes(keywordValue) ||
        contact.country?.toLowerCase().includes(keywordValue) ||
        contact.countryName?.toLowerCase().includes(keywordValue) ||
        contact.office?.toLowerCase().includes(keywordValue)
    })

    const _suggestedContactsActive = suggestedContactsFiltered.slice(0, Math.min(10, suggestedContactsFiltered.length))
    dispatch(setSuggestedContactsActive(_suggestedContactsActive));
    dispatch(setSuggestedContactsTotalPage(Math.max(Math.ceil(suggestedContactsFiltered.length / 10), 1)))
  }

  const viewSuggestedContactsList = (curPage) => {
    setSuggestedCurPage(curPage);
    setSuggestedCurPageInput(curPage);
    setChkAll2(false);

    const startIndex = 10 * (curPage - 1);
    let suggestedContactsFiltered = suggestedContacts

    if (activeTab === "WeCrestSuggest" && suggestedKeyword != "") {
      suggestedContactsFiltered = suggestedContacts.filter(contact => {
        return contact.emailAddress.toLowerCase().includes(suggestedKeyword) ||
          contact.firstName?.toLowerCase().includes(suggestedKeyword) ||
          contact.lastName?.toLowerCase().includes(suggestedKeyword) ||
          contact.position?.toLowerCase().includes(suggestedKeyword) ||
          contact.title?.toLowerCase().includes(suggestedKeyword) ||
          contact.countr?.toLowerCase().includes(suggestedKeyword) ||
          contact.countryName?.toLowerCase().includes(suggestedKeyword) ||
          contact.office?.toLowerCase().includes(suggestedKeyword)
      })
    }
    // console.log("view: ", {
    //   activeTab, suggestedKeyword, curPage, startIndex, endIndex: Math.min(startIndex+10, suggestedContactsFiltered.length),
    //   suggestedContactsFiltered: suggestedContactsFiltered.length
    // })
    const _suggestedContactsActive = suggestedContactsFiltered.slice(startIndex, Math.min(startIndex + 10, suggestedContactsFiltered.length))
    dispatch(setSuggestedContactsActive(_suggestedContactsActive));
  }

  const importedContactsChk = (chkIdx, e) => {
    let chkCnt = 0;
    let showCnt = 0;
    let _importedContacts = cloneDeep(importedContacts);
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    _importedContacts = _importedContacts.map((contact, idx) => {
      if (chkIdx == "chkAll") {
        contact.checked = value;
      } else if (shift && ctrlOrCmd && lastContactCheckedIdx != -1) {
        const start = Math.min(chkIdx, lastContactCheckedIdx);
        const end = Math.max(chkIdx, lastContactCheckedIdx);
        if (idx >= start && idx <= end) {
          contact.checked = value;
        }
      } else if (chkIdx == idx) {
        contact.checked = value;
      }

      // if(contact.show){
      showCnt++;
      if (contact.checked) chkCnt++;
      // } 

      return contact;
    });

    if (showCnt === chkCnt) {
      setImportedChkAll(true);
    } else {
      setImportedChkAll(false);
    }
    if (chkIdx != "chkAll") setLastContactCheckedIdx(chkIdx);
    else setLastContactCheckedIdx(-1);
    dispatch(onChangeImportedContacts(_importedContacts));
  }

  const suggestedContactsChk = (chkIdx, e) => {
    let chkCnt = 0;
    let showCnt = 0;
    let _suggestedContacts = cloneDeep(suggestedContactsActive);
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    _suggestedContacts = _suggestedContacts.map((contact, idx) => {
      if (chkIdx == "chkAll") {
        if (contact.show) contact.checked = value;
      } else if (shift && ctrlOrCmd && lastContactCheckedIdx != -1) {
        const start = Math.min(chkIdx, lastContactCheckedIdx);
        const end = Math.max(chkIdx, lastContactCheckedIdx);
        if (idx >= start && idx <= end) {
          contact.checked = value;
        }
      } else if (chkIdx == idx) {
        contact.checked = value;
      }

      if (contact.show) {
        showCnt++;
        if (contact.checked) chkCnt++;
      }

      return contact;
    });

    if (showCnt === chkCnt) {
      setChkAll2(true);
    } else {
      setChkAll2(false);
    }
    if (chkIdx != "chkAll") setLastContactCheckedIdx(chkIdx);
    else setLastContactCheckedIdx(-1);
    // console.log(chkIdx, _suggestedContacts);
    dispatch(onChangeSuggestedContacts(_suggestedContacts));
  }

  const memberConfirmedContactsChk = (chkIdx, e) => {
    let chkCnt = 0;
    let showCnt = 0;
    let _memberConfirmedContacts = cloneDeep(memberConfirmedContacts);
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    _memberConfirmedContacts = _memberConfirmedContacts.map((contact, idx) => {
      if (chkIdx == "chkAll") {
        if (contact.show) contact.checked = value;
      } else if (shift && ctrlOrCmd && lastContactCheckedIdx != -1) {
        const start = Math.min(chkIdx, lastContactCheckedIdx);
        const end = Math.max(chkIdx, lastContactCheckedIdx);
        if (idx >= start && idx <= end) {
          contact.checked = value;
        }
      } else if (chkIdx == idx) {
        contact.checked = value;
      }

      if (contact.show) {
        showCnt++;
        if (contact.checked) chkCnt++;
      }

      return contact;
    });

    if (showCnt === chkCnt) {
      setChkAllMemberConfirmedContacts(true);
    } else {
      setChkAllMemberConfirmedContacts(false);
    }
    if (chkIdx != "chkAll") setLastContactCheckedIdx(chkIdx);
    else setLastContactCheckedIdx(-1);
    dispatch(onChangeMemberConfirmedContacts(_memberConfirmedContacts));
  }

  useEffect(() => {
    setLastContactCheckedIdx(-1);
  }, [validation.values.submitType])

  const addAdress = (type, suggestIdx) => {
    // let _contactsDetails = cloneDeep(contactsDetails);
    let addAdressList = [];

    if (type == 'imported') {
      if (importedContacts && importedContacts.length) {
        importedContacts.map((contact, idx) => {
          if (suggestIdx == -1) {
            if (contact.show && contact.checked) {
              let _contact = cloneDeep(contact);
              _contact.modFlag = "I";
              _contact.sendYn = "Y";
              _contact.hagueSendYn = "Y";
              _contact.filerSendYn = "Y";
              _contact.pctSendYn = "Y";
              _contact.targetGroupNo = targetGroupNo;
              addAdressList.push(_contact);
            }
          } else {
            if (idx == suggestIdx) {
              let _contact = cloneDeep(contact);
              _contact.modFlag = "I";
              _contact.sendYn = "Y";
              _contact.hagueSendYn = "Y";
              _contact.filerSendYn = "Y";
              _contact.pctSendYn = "Y";
              _contact.targetGroupNo = targetGroupNo;
              addAdressList.push(_contact);
            }
          }
        });
      }
    } else if (type == 'suggest') {

      if (suggestedContactsActive && suggestedContactsActive.length) {
        suggestedContactsActive.map((contact, idx) => {
          if (suggestIdx == -1) {
            if (contact.show && contact.checked) {
              let _contact = cloneDeep(contact);
              _contact.modFlag = "I";
              _contact.sendYn = contact.ipType.includes("Trademark") || contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.hagueSendYn = contact.ipType.includes("Design") || contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.filerSendYn = contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.pctSendYn = contact.ipType.includes("Patent") || contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.targetGroupNo = targetGroupNo;
              addAdressList.push(_contact);
            }
          } else {
            if (idx == suggestIdx) {
              let _contact = cloneDeep(contact);
              _contact.modFlag = "I";
              _contact.sendYn = contact.ipType.includes("Trademark") || contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.hagueSendYn = contact.ipType.includes("Design") || contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.filerSendYn = contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.pctSendYn = contact.ipType.includes("Patent") || contact.ipType.includes("General") || contact.ipType === null ? "Y" : "N";
              _contact.targetGroupNo = targetGroupNo;
              addAdressList.push(_contact);
            }
          }
        });
      }
    } else {
      if (memberConfirmedContacts && memberConfirmedContacts.length) {
        memberConfirmedContacts.map((contact, idx) => {
          if (suggestIdx == -1) {
            if (contact.show && contact.checked) {
              let _contact = cloneDeep(contact);
              _contact.modFlag = "I";
              _contact.sendYn = "Y";
              _contact.hagueSendYn = "Y";
              _contact.filerSendYn = "Y";
              _contact.pctSendYn = "Y";
              _contact.targetGroupNo = targetGroupNo;
              addAdressList.push(_contact);
            }
          } else {
            if (idx == suggestIdx) {
              let _contact = cloneDeep(contact);
              _contact.modFlag = "I";
              _contact.sendYn = "Y";
              _contact.hagueSendYn = "Y";
              _contact.filerSendYn = "Y";
              _contact.pctSendYn = "Y";
              _contact.targetGroupNo = targetGroupNo;
              addAdressList.push(_contact);
            }
          }
        });
      }
    }

    if (addAdressList.length === 0) {
      dispatch(onSetContacsDetailResult(7));
      return false;
    }

    let checkDupeEmailAddress = [];
    let validEmailCount = 0;
    contactsDetails.contactsList.map((contact, contactIdx) => {
      addAdressList.map((contact2, contactIdx2) => {
        if (contact.emailAddress && contact.emailAddress != '' && contact.emailAddress.toLowerCase() == contact2.emailAddress.toLowerCase() && !checkDupeEmailAddress.includes(contact.emailAddress)) {
          checkDupeEmailAddress.push(contact.emailAddress)
        }
      })
      if (contact.unsubscribe !== 'Y' && contact.emailAddress && contact.emailAddress != '') {
        validEmailCount++;
      }
    })

    if (checkDupeEmailAddress.length > 0) {
      setDupeEmailAddress(checkDupeEmailAddress);
      dispatch(onSetContacsDetailResult(9));
    } else if (checkContactListLimit(contactsDetails.contactsList, addAdressList, 'add') == false) {
      //console.log('validEmailCount : ' + validEmailCount + ', addAdressList.length : ' + addAdressList.length);
      dispatch(onSetContacsDetailResult(11));
    } else {
      // dispatch(onSaveContactsSimple(addAdressList));
      setAddSimpleAdressList(addAdressList);
      dispatch(onCheckEmailUnsubscribe(addAdressList, 'SIMPLE', 'Detail'));
    }

    /*
    let oriEmailAdressList = [];
    contactsDetails.contactsList.map((contact, contactIdx) => {

      if(!(contact.modFlag == "I" && (!contact.emailAddress || contact.emailAddress == null || contact.emailAddress == ""))) {
        oriEmailAdressList.push(contact);
      }
    })

    _contactsDetails.contactsList  = oriEmailAdressList.concat(addAdressList); // contactsDetails.contactsList.concat(addAdressList);

    dispatch(onChangeContactsDetails(_contactsDetails));
    showSuccessAddToast();
    */
  }

  const checkContactListLimit = (existingList, newList, type) => {
    let validMNNCount = 0
    let validHNCount = 0
    let validFRCount = 0
    let validPCTCount = 0

    const countContactsByType = (contactList) => {
      contactList.forEach((contact) => {
        if (contact.unsubscribe !== 'Y' && contact.emailAddress && contact.emailAddress !== '') {
          if (contact.sendYn === 'Y') validMNNCount++;
          if (contact.hagueSendYn === 'Y') validHNCount++;
          if (contact.filerSendYn === 'Y') validFRCount++;
          if (contact.pctSendYn === 'Y') validPCTCount++;
        }
      });
    };

    countContactsByType(existingList);
    countContactsByType(newList);

    if (type === 'add' && (validMNNCount > 3 || validHNCount > 3 || validFRCount > 3 || validPCTCount > 3)
      || type === 'enable' && (validMNNCount >= 3 || validHNCount >= 3 || validFRCount >= 3 || validPCTCount >= 3)) {
      return false;
    } else {
      return true;
    }
  }

  const contactChk = (type) => {
    let chkCnt = 0;
    let notSaveCnt = 0;

    // let notDelEmailAdressList = [];
    let _newContactsList = [];
    contactsDetails.contactsList.map((contact, contactIdx) => {
      if (contact.checked === true) {
        chkCnt++;
      }

      if (type == 'Unsubscribed') {
        if (contact.checked === true) {
          // chkCnt++;
          if (contact.modFlag == "I") {
            notSaveCnt++;
          }
        }
      } else {
        // console.log('checked : ' + contact.checked + ', modFlag : ' + contact.modFlag);
        if (!(contact.checked && contact.modFlag == "I")) {
          _newContactsList.push(contact);
        }
      }
    })

    if (chkCnt === 0) {
      dispatch(onSetContacsDetailResult(2));
      return false;
    }

    if (type == 'Unsubscribed') {
      if (notSaveCnt > 0) {
        dispatch(onSetContacsDetailResult(3));
        return false;
      }
    } else {
      if (_newContactsList.length == 0) {
        let _contactsDetails = cloneDeep(contactsDetails);
        let newRow = [{ "targetGroupNo": targetGroupNo, "emailSeq": null, "emailAddress": null, "modFlag": "I", "type": "To", "firstName": null, "lastName": null, "title": null, "position": null, "country": "", "office": "", "unsubscribe": "N", "checked": true, "sendYn": "Y", "hagueSendYn": "Y", "filerSendYn": "Y", "pctSendYn": "Y" }];
        _contactsDetails.contactsList = newRow;

        dispatch(onChangeContactsDetails(_contactsDetails));

        return false;
      } else {
        chkCnt = 0;
        notSaveCnt = 0;

        _newContactsList.map((contact, contactIdx) => {
          if (contact.checked === true) {
            chkCnt++;
          }

          if (contact.modFlag == "I") {
            notSaveCnt++;
          }
        })

        let _contactsDetails = cloneDeep(contactsDetails);
        _contactsDetails.contactsList = _newContactsList;
        dispatch(onChangeContactsDetails(_contactsDetails));

        if (chkCnt === 0) {
          return false;
        } else if (notSaveCnt > 0) {
          dispatch(onSetContacsDetailResult(3));
          return false;
        }
      }
    }

    /*
        if(type == "Delete" && notSaveCnt > 0){
          let _contactsDetails = cloneDeep(contactsDetails);
          _contactsDetails.contactsList  = notDelEmailAdressList;
    
          dispatch(onChangeContactsDetails(_contactsDetails));
    
          if (chkCnt == notSaveCnt) {
            return false;
          }
        }
    */

    return true;
  }

  const saveValidation = () => {
    let chkCnt = 0;
    let noEmail = false;
    // let noFirstName = false;
    let invalidEmails = [];
    let regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,15}$/i;

    let checkUnsubsEmail = [];
    let checkDupeEmailAddress = [];

    contactsDetails.contactsList.map((contact, contactIdx) => {
      if (contact.checked === true) {
        chkCnt++;
        if (!contact.emailAddress) {
          noEmail = true;
        } else if (!regex.test(contact.emailAddress)) {
          invalidEmails.push(contact.emailAddress);
        }

        // if (contact.modFlag === "I") {
        checkUnsubsEmail.push(contact);
        // }

        // if(!contact.firstName){
        //   noFirstName = true;
        // }

        contactsDetails.contactsList.map((contact2, contactIdx2) => {
          // console.log("[1] ", contact.emailAddress, contact.unsubscribe)
          if (contactIdx != contactIdx2 && contact.emailAddress && contact.emailAddress != '' && contact.emailAddress.toLowerCase() == contact2.emailAddress.toLowerCase() && !checkDupeEmailAddress.includes(contact.emailAddress)) {
            checkDupeEmailAddress.push(contact.emailAddress)
          }
        })
      }
    })

    // console.log(">>> [saveValidation]", noEmail, checkDupeEmailAddress, checkUnsubsEmail, invalidEmails)

    if (checkDupeEmailAddress.length > 0) {
      // console.log(">>> checkDupeEmailAddress > 0", checkDupeEmailAddress)
      setDupeEmailAddress(checkDupeEmailAddress);
      dispatch(onSetContacsDetailResult(9));
      return false;
    }

    if (checkContactListLimit(contactsDetails.contactsList, [], 'add') == false) {
      //console.log('contactsDetails.contactsList.length : ' + contactsDetails.contactsList.length)
      dispatch(onSetContacsDetailResult(11));
      return false;
    }

    if (chkCnt === 0) {
      dispatch(onSetContacsDetailResult(2));
      return false;
    } else if (noEmail) {
      dispatch(onSetContacsDetailResult(4));
      return false;
    } else if (invalidEmails.length > 0) {
      dispatch(onSetContacsDetailResult(5));
      return false;
    } else {
      // console.log('checkUnsubsEmail.length : ' + checkUnsubsEmail.length)
      if (checkUnsubsEmail.length > 0) {
        // console.log('>>> checkUnsubsEmail : ' + JSON.stringify(checkUnsubsEmail))
        dispatch(onCheckEmailUnsubscribe(checkUnsubsEmail, 'INPUT', 'Detail'));
        return false;
      } else {
        return true;
      }
    }
  }

  function showSuccessAddToast() {
    const ele = "success";
    const position = "toast-bottom-left"
    const title = ""
    // let message = "Add contacts!"

    //Close Button
    const closeButton = false

    //Debug
    const debug = false

    //Progressbar
    const progressBar = false

    //Duplicates
    const preventDuplicates = false

    //Newest on Top
    const newestOnTop = false

    //position class
    let positionClass = "toast-bottom-left"

    //Show Easing
    const showEasing = "swing";

    //Hide Easing
    const hideEasing = "linear";

    //show method
    const showMethod = "fadeIn";

    //Hide method
    const hideMethod = "fadeOut";

    //show duration
    const showDuration = 300;

    //Hide duration
    const hideDuration = 1000;

    //timeout
    const timeOut = 1000;

    //extended timeout
    const extendedTimeOut = 1000;

    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      debug: debug,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showEasing: showEasing,
      hideEasing: hideEasing,
      showMethod: showMethod,
      hideMethod: hideMethod,
      showDuration: showDuration,
      hideDuration: hideDuration
    }

    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    toastr.success(toastMessage, title)
  }

  useEffect(() => {
    dispatch(onGetAllCountryList());
  }, []);

  return (
    <React.Fragment>
      <div className={props.targetGroupNo != undefined ? null : "page-content"}>
        <div className="container-fluid">
          {/* Header */}
          <Row>
            <Col className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Contacts details</h4>
                {props.targetGroupNo != undefined ? null :
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <Link to="/contacts">List</Link>
                      &nbsp;<span> &gt; Detail</span>
                    </ol>
                  </div>}
              </div>
            </Col>
          </Row>

          {/* Information */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    {contactsDetails && Object.keys(contactsDetails).length !== 0 ?
                      <Col
                        lg={pctRepList && Array.isArray(pctRepList) && pctRepList.length > 0 ? "4" : "5"}
                        xl="4"
                      >
                        <div className="d-flex gap-2">
                          <Link to="#" className={contactsDetails.starred ? "text-warning" : "text-muted"}
                            onClick={(e) => {
                              validation.setFieldValue("submitType", contactsDetails.starred ? "Unstar" : "Star")
                              validation.handleSubmit(validation.values);
                            }}>
                            <i className="uil uil-star font-size-18" id="Starred"></i>
                            <UncontrolledTooltip placement="top" target="Starred" className="domain-correct-tooltip">
                              {contactsDetails.starred ? "Remove from starred" : "Star"}
                            </UncontrolledTooltip>
                          </Link>
                          <Link to="#" className={contactsDetails.hidden ? "text-danger" : "text-muted"}
                            onClick={(e) => {
                              validation.setFieldValue("submitType", contactsDetails.hidden ? "Unhide" : "Hide")
                              validation.handleSubmit(validation.values);
                            }}>
                            <i className="uil uil-eye-slash font-size-18" id="Hidden"></i>
                            <UncontrolledTooltip placement="top" target="Hidden" className="domain-correct-tooltip">
                              {contactsDetails.hidden ? "Unhide" : "Hide"}
                            </UncontrolledTooltip>
                          </Link>
                        </div>
                        <br />

                        Entity name: <h5 style={{whiteSpace:'pre-wrap'}}>{contactsDetails.targetGroupName}</h5>
                        Entity domain:
                        <h5 style={{ display: 'flex', gap: '4px', alignItems: 'center' }} >
                          {
                            contactsDetails.domainCorrectYn &&
                              contactsDetails.domainCorrectYn === "Y" &&
                              contactsDetails.domain &&
                              contactsDetails.domain !== "NOT_SAME" &&
                              contactsDetails.unsubscribeYn !== "Y" &&
                              contactsDetails.domain !== "NOT_MAX"
                              ? <><i className="bx bx-badge-check font-size-18 text-success"></i> </>
                              : null
                          }
                          {
                            contactsDetails.domain &&
                              contactsDetails.domain !== "NOT_SAME" &&
                              contactsDetails.domain !== "NOT_MAX" &&
                              contactsDetails.unsubscribeYn == "Y" ?
                              "Unsubscribed" :
                              contactsDetails.domain &&
                                contactsDetails.domain !== "NOT_SAME"
                                && contactsDetails.domain !== "NOT_MAX" ?
                                <a href='#' onClick={() => {
                                  if (contactsDetails.domain !== "Unsubscribed") {
                                    window.open(`${httpDomains.includes(contactsDetails.domain) ? "http" : "https"}://www.${contactsDetails.domain}`, "_blank");
                                  }
                                }}>{contactsDetails.domain}</a>
                                : "N/A"
                          }
                          {
                            contactsDetails.domain && contactsDetails.globalFirmYn && contactsDetails.branch &&
                            contactsDetails.domain !== "NOT_SAME"
                            && contactsDetails.domain !== "NOT_MAX"
                            && contactsDetails.globalFirmYn === "Y"
                            && contactsDetails.branch.length > 0
                            &&
                            <Link to="#">
                              <i className="uil uil-globe font-size-20 text-primary" id="globalFirm"></i>
                              <UncontrolledTooltip placement="top" target="globalFirm" className="domain-correct-tooltip">
                                Global firm with offices in {Array.from(new Set(contactsDetails.branch.split(", "))).join(", ")}
                              </UncontrolledTooltip>
                            </Link>
                          }
                        </h5>
                        Is this domain correct?&nbsp;
                        <Link to="#" >
                          <i className="uil uil-question-circle font-size-18 text-success" id="domain_correct_info"></i>
                          <UncontrolledTooltip placement="top" target="domain_correct_info" className="domain-correct-tooltip">
                            WeCrest's AI-driven algorithm believes that this is the correct email/web domain for this entity. Please help us improve the accuracy of our data by letting us know whether you believe this domain is correct or incorrect. If you believe it is incorrect, you can also suggest a correction.
                          </UncontrolledTooltip>
                        </Link>

                        <div>
                          <button type="button" class={userSuggestDomain.correctYn === 'Y' ? "waves-effect waves-light btn btn-success" : "waves-effect waves-light btn btn-outline-success"}
                            onClick={() => {
                              if (userSuggestDomain.correctYn !== 'Y') {
                                dispatch(onSaveDomainCorrectYn({ targetGroupNo: targetGroupNo, correctYn: 'Y' }));
                              }
                            }}>
                            <i className="uil uil-check font-size-14"></i> Correct {domainCorrectYnCount && domainCorrectYnCount.correctY ? domainCorrectYnCount.correctY : 0}
                          </button>
                          &nbsp;&nbsp;
                          <button type="button" class={userSuggestDomain.correctYn === 'N' ? "waves-effect waves-light btn btn-danger" : "waves-effect waves-light btn btn-outline-danger"}
                            onClick={() => {
                              if (userSuggestDomain.correctYn !== 'N') {
                                setDomainSuggestAlert(true);
                              }
                            }}>
                            <i className="uil uil-times font-size-14"></i> Incorrect {domainCorrectYnCount && domainCorrectYnCount.correctN ? domainCorrectYnCount.correctN : 0}
                          </button>
                        </div>

                        Last updated: <h5>{contactsDetails.lastTargetEmailModDate ? contactsDetails.lastTargetEmailModDate : "N/A"}</h5>
                      </Col>
                      : null}

                    {
                      pctRepList && Array.isArray(pctRepList) && pctRepList.length > 0 && (
                        <Col lg="4" xl="4">
                          <h4 className="card-title mb-3">Other agents</h4>
                          {
                            pctRepList.map(rep => {
                              return <p key={rep.repGroupNo}>{rep.repName}</p>
                            })
                          }
                        </Col>
                      )
                    }

                    <Col
                      lg={pctRepList && Array.isArray(pctRepList) && pctRepList.length > 0 ? "4" : "7"}
                      xl={pctRepList && Array.isArray(pctRepList) && pctRepList.length > 0 ? "4" : "8"}
                    >
                      <h4 className="card-title mb-3">Memo</h4>
                      <SimpleBar style={{ maxHeight: "200px" }}>
                        <div className={validation.touched.textarea && validation.errors.textarea ? null : "mb-3"}>
                          <Input type="textarea" name="textarea"
                            placeholder="Write your memo here"
                            rows="3"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.textarea || ""}
                            invalid={
                              validation.touched.textarea && validation.errors.textarea ? true : false
                            }
                          />
                          {validation.touched.textarea && validation.errors.textarea ? (
                            <FormFeedback type="invalid">{validation.errors.textarea}</FormFeedback>
                          ) : null}
                        </div>
                        <div class="float-md-end">
                          <button type="submit" className="btn btn-primary waves-effect waves-light"
                            onClick={(e) => {
                              validation.setFieldValue("submitType", "memo");
                              validation.handleSubmit(validation.values);
                            }}>save</button>
                        </div>
                      </SimpleBar>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {
            loading ?
              <LoadingModal loading={loading}></LoadingModal>
              : null
          }
          {success ? (
            <SweetAlert
              title={success}
              timeout={2000}
              showCloseButton={false}
              showConfirm={false}
              success
              onConfirm={() => {
                dispatch(onSetSuccess(""));
              }}
            ></SweetAlert>
          ) : null}
          {detailResult !== -1 ? (
            <SweetAlert
              onConfirm={() => {
                dispatch(onSetContacsDetailResult(-1));
                setDupeEmailAddress([]);
              }}
            >
              {
                detailResult < 9 ? 
                  errMsg[detailResult] : 
                    <>
                      {
                        <>
                          {
                            errMsg[detailResult]
                          } <br />
                          {
                            detailResult == 9 ? 
                              "[" + dupeEmailAddress + "]" :
                                detailResult == 10 ? unsubsEmailAddress1 :
                                detailResult == 12 ? unsubsEmailAddress2 : ""
                          }
                        </> 
                      }
                    </>
              }
            </SweetAlert>
          ) : null}
          {confirmAlert ? (
            <SweetAlert
              title="Are you sure?"
              warning
              showCancel
              confirmBtnText="Confirm"
              cancelBtnText="No, go back"
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => {
                validation.handleSubmit(validation.values);
                setConfirmAlert(false);
              }}
              onCancel={() => setConfirmAlert(false)}
            >
              {confirmMsg}
            </SweetAlert>
          ) : null}
          {domainSuggestAlert ? (
            <SweetAlert
              title="Do you know the correct domain?"
              showCancel
              confirmBtnText="Confirm"
              cancelBtnText="No, go back"
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => {
                if (userSuggestDomain.knowCorrectDomainYn === 'Y' && (userSuggestDomain.suggestDomain == null || userSuggestDomain.suggestDomain == '')) {
                  setRequireDomainAlert(true);
                } else {
                  dispatch(onSaveDomainCorrectYn(
                    {
                      ...userSuggestDomain,
                      correctYn: 'N',
                      targetGroupName: contactsDetails.targetGroupName,
                    }
                  ));
                  setDomainSuggestAlert(false);
                  setRequireDomainAlert(false);
                }

              }}
              onCancel={() => setDomainSuggestAlert(false)}
            >
              <Row className="mb-1">
                <div className="col-md-2 form-check" style={{ paddingLeft: '2em', paddingTop: "5px" }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="emailSent"
                    id="emailSentN"
                    onChange={() => {
                      dispatch(onChangeUserSuggestDomain(
                        {
                          ...userSuggestDomain,
                          knowCorrectDomainYn: 'Y',
                        }
                      ));
                    }}
                    value="Y"
                    checked={userSuggestDomain.knowCorrectDomainYn === 'Y'}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="emailSentN"
                  >
                    Yes
                  </label>
                </div>
                <div className="col-md-2 form-check" style={{ paddingLeft: '2em', paddingTop: "5px" }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="emailSent"
                    id="emailSentY"
                    onChange={() => {
                      dispatch(onChangeUserSuggestDomain(
                        {
                          ...userSuggestDomain,
                          knowCorrectDomainYn: 'N',
                          suggestDomain: '',
                        }
                      ));
                      setRequireDomainAlert(false);
                    }}
                    value="N"
                    checked={userSuggestDomain.knowCorrectDomainYn === 'N'}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="emailSentY"
                  >
                    No
                  </label>
                </div>
                <div className="col-md-8">
                  <Input
                    className="form-control"
                    type="text"
                    placeholder="Enter correct domain"
                    onChange={(e) => {
                      dispatch(onChangeUserSuggestDomain(
                        {
                          ...userSuggestDomain,
                          suggestDomain: e.target.value,
                        }
                      ));
                    }}
                    value={userSuggestDomain.suggestDomain}
                    disabled={userSuggestDomain.knowCorrectDomainYn === 'N' ? true : false}
                  />
                </div>
              </Row>
              {requireDomainAlert ?
                <div class="mt-2 text-danger row display-flex horizon-align-center">Please enter your suggestion.</div>
                : null
              }
            </SweetAlert>
          ) : null}

          <Nav pills className="col-md-7 nav-justified bg-light">
            <NavItem className="col-md-2 waves-effect waves-light">
              <NavLink
                style={contactsDetails && contactsDetails?.unsubscribeYn === "Y" ? { cursor: "pointer", height: "100%", paddingTop: "13px" } : { cursor: "pointer", height: "100%" }}
                className={classnames({
                  active: activeTab === "Contacts",
                })}
                onClick={() => {
                  toggleActiveTab("Contacts")
                }}
              >
                <span>Contacts</span>
              </NavLink>
            </NavItem>
            {memberConfirmedContacts.length > 0 ?
              <NavItem className="col-md-3 waves-effect waves-light">
                <NavLink
                  style={contactsDetails && contactsDetails?.unsubscribeYn === "Y" ? { cursor: "pointer", height: "100%", paddingTop: "13px" } : { cursor: "pointer", height: "100%" }}
                  className={classnames({
                    active: activeTab === "MemberConfirmedContacts",
                  })}
                  onClick={() => {
                    toggleActiveTab("MemberConfirmedContacts")
                  }}
                >
                  <span>Member Confirmed contacts</span>
                </NavLink>
              </NavItem>
              : null}
            {memberConfirmedContacts.length === 0 ?
              <NavItem className="col-md-3 waves-effect waves-light">
                <NavLink
                  style={{ cursor: "pointer", height: "100%" }}
                  className={classnames({
                    active: activeTab === "WeCrestSuggest",
                  })}
                  onClick={() => {
                    toggleActiveTab("WeCrestSuggest")
                  }}
                >
                  <span className="d-flex align-items-center justify-content-center gap-2">
                    WeCrest suggested contacts
                    {
                      contactsDetails && contactsDetails?.unsubscribeYn === "Y" && <i className="uil uil-info-circle font-size-22" id="weCrestSuggestInfo"></i>
                    }
                  </span>
                </NavLink>
              </NavItem>
              : null}
            <NavItem className="col-md-2 waves-effect waves-light">
              <NavLink
                style={contactsDetails && contactsDetails?.unsubscribeYn === "Y" ? { cursor: "pointer", height: "100%", paddingTop: "13px" } : { cursor: "pointer", height: "100%" }}
                className={classnames({
                  active: activeTab === "ImportedEmail",
                })}
                onClick={() => {
                  toggleActiveTab("ImportedEmail")
                }}
              >
                <span>Imported email addresses</span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={activeTab}
            className="text-muted"
          >
            <TabPane tabId="Contacts">
              <Row>
                <Col lg="12">
                  <Card>
                    <div className="p-4">
                      <Media className="d-flex align-items-center">
                        <div className="flex-grow-1 overflow-hidden">
                          <p className={sendableEmailFlag && sendableHagueEmailFlag && sendableFilerEmailFlag && sendablePctEmailFlag ? "text-muted mb-0" : "text-danger mb-0"}>
                            In order to send an email from{" "}
                            {
                              [
                                !sendableEmailFlag && "Madrid Notifier",
                                !sendableHagueEmailFlag && "Hague Notifier",
                                !sendableFilerEmailFlag && "Filer Rankings",
                                !sendablePctEmailFlag && "PCT Notifier",
                              ]
                                .filter(Boolean) // remove null/false
                                .join(", ")
                            }
                            {" "}at least one contact information must be saved with sending enabled.
                          </p>
                        </div>
                      </Media>
                    </div>
                    <CardBody>
                      <CardTitle className="text-muted mb-0">
                        <Row className="mb-3">
                          <span className="button-items">
                            {
                              contactsDetails 
                              && contactsDetails?.contactsList 
                              && contactsDetails?.contactsList.length > 0 
                              && (
                                contactsDetails?.contactsList.filter(contact => contact.checked).length == 0 ||
                                contactsDetails?.contactsList.filter(contact => contact.checked).every(contact => contact.unsubscribe !== 'Y' && contact.unsubscribe !== "D")
                              ) && 
                              <>
                                <Button type="button" color="primary" outline className="waves-effect waves-light"
                                  onClick={() => {
                                    if (saveValidation()) {
                                      validation.setFieldValue("submitType", "Save");
                                      setConfirmMsg("Are you sure you want to save the selected email(s)?");
                                      setConfirmAlert(true);
                                    }
                                  }}
                                >Save contact
                                </Button>
                                <Button type="button" color="primary" outline className="waves-effect waves-light"
                                  onClick={() => {
                                    validation.setFieldValue("submitType", enableOrDisable);
                                    setConfirmMsg("Are you sure you want to " + enableOrDisable.toLowerCase() + " email sending from selected email(s) for all tools?");
                                    setConfirmAlert(true);
                                  }}
                                >{enableOrDisable} email sending
                                </Button>
                                <Button type="button" color="primary" outline className="waves-effect waves-light"
                                  onClick={() => {
                                    if (contactChk("Unsubscribed")) {
                                      validation.setFieldValue("submitType", "Unsubscribed");
                                      setConfirmMsg("Are you sure you want to unsubscribe the selected email(s)?");
                                      setConfirmAlert(true);
                                    }
                                  }}
                                >Unsubscribe contact
                                </Button>
                              </>
                            }
                            {
                              contactsDetails 
                              && contactsDetails?.contactsList 
                              && contactsDetails?.contactsList.length > 0 &&
                              <Button type="button" color="primary" outline className="waves-effect waves-light"
                                onClick={() => {
                                  if (contactChk("Delete")) {
                                    validation.setFieldValue("submitType", "Delete");
                                    setConfirmMsg("Are you sure you want to delete the selected email(s)?");
                                    setConfirmAlert(true);
                                  }
                                }}
                              >Delete contact
                              </Button>
                            }
                          </span>
                        </Row>
                      </CardTitle>
                      <div className="table-responsive">
                        {contactsDetails && Object.keys(contactsDetails).length !== 0 ?
                          <Table className="table mb-0">
                            <thead>
                              <tr>
                                <th style={{ verticalAlign: "middle", textAlign: "center" }}><input type="checkbox" checked={contactsDetails.checked} onClick={(e) => contactCheck("chkAll", e)} /></th>
                                <th>Email address*</th>
                                <th>First name</th>
                                <th>Last name</th>
                                <th>Title</th>
                                <th>Position</th>
                                <th>Country</th>
                                <th>Office</th>
                                <th>Send via Madrid Notifier?</th>
                                <th>Send via Hague Notifier?</th>
                                <th>Send via Filer Rankings?</th>
                                <th>Send via PCT Notifier?</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {contactsDetails.contactsList.map((contact, contactIdx) => {
                                return (
                                  <>
                                    <tr id={`contact-${contactIdx}`} className={contact.modFlag === "I" ? "bg-soft-danger" : null}>
                                      <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <input type="checkbox"
                                          checked={contact.checked}
                                          onClick={(e) => contactCheck(contactIdx, e)}
                                        />
                                      </td>
                                      <td><input type="text" className="form-control" onChange={(e) => { contact.unsubscribe === "N" && handleInput("emailAddress", contactIdx, e.target.value) }} value={contact.emailAddress ? contact.emailAddress : ""} disabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"} /></td>
                                      <td><input type="text" className="form-control" onChange={(e) => { contact.unsubscribe === "N" && handleInput("firstName", contactIdx, e.target.value) }} value={contact.firstName ? contact.firstName : ""} disabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"} /></td>
                                      <td><input type="text" className="form-control" onChange={(e) => { contact.unsubscribe === "N" && handleInput("lastName", contactIdx, e.target.value) }} value={contact.lastName ? contact.lastName : ""} disabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"} /></td>
                                      <td><input type="text" className="form-control" onChange={(e) => { contact.unsubscribe === "N" && handleInput("title", contactIdx, e.target.value) }} value={contact.title ? contact.title : ""} disabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"} /></td>
                                      <td><input type="text" className="form-control" onChange={(e) => { contact.unsubscribe === "N" && handleInput("position", contactIdx, e.target.value) }} value={contact.position ? contact.position : ""} disabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"} /></td>
                                      <td>
                                        {
                                          countryList && countryList.length > 0 ? (
                                            <Select
                                                classNamePrefix="select2-selection"
                                                name="country"
                                                placeholder="Select country"
                                                options={
                                                  countryList
                                                    .sort((a, b) => a.crName.localeCompare(b.crName))
                                                    .map(c => ({value: c.crCode, label: `${c.crCode} ${c.crName}`}))
                                                }
                                                value={
                                                  contact.country ? 
                                                    countryList
                                                      .filter(c => c.crCode == contact.country)
                                                      .map(c => ({value: c.crCode, label: `${c.crCode} ${c.crName}`}))
                                                  : ""
                                                }
                                                isDisabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"}
                                                isClearable
                                                isSearchable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (base) => ({
                                                      ...base,
                                                      width: 150,
                                                    }),

                                                    menu: (base) => ({
                                                      ...base,
                                                      width: 200,
                                                    }),
                                                }}
                                                onChange={(selectedOption) => {
                                                  if (contact.unsubscribe === "N") {
                                                    handleInput("country", contactIdx, selectedOption ? selectedOption.value : '')
                                                  }
                                                }}
                                            />
                                          ) : <></>
                                        }
                                      </td>
                                      <td><input type="text" className="form-control" onChange={(e) => { contact.unsubscribe === "N" && handleInput("office", contactIdx, e.target.value) }} value={contact.office ? contact.office : ""} disabled={contact.unsubscribe === 'Y' || contact.unsubscribe === "D"} /></td>
                                      {contact.unsubscribe === "Y" ?
                                        <td colSpan={4} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                          <>
                                            <i className="uil uil-envelope-block font-size-22 text-danger" id={"Unsubscribed_" + contactIdx}></i>
                                            <UncontrolledTooltip placement="top" target={"Unsubscribed_" + contactIdx} className="domain-correct-tooltip">
                                              Unsubscribed
                                            </UncontrolledTooltip>
                                          </>
                                        </td>
                                        :
                                        contact.unsubscribe === "D" ?
                                        <td colSpan={4} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                          <>
                                            <i className="uil uil-envelope-block font-size-22 text-danger" id={"Deleted_" + contactIdx}></i>
                                            <UncontrolledTooltip placement="top" target={"Deleted_" + contactIdx} className="domain-correct-tooltip">
                                              This email address is no longer available
                                            </UncontrolledTooltip>
                                          </>
                                        </td>
                                        :
                                        <>
                                          <td style={{ verticalAlign: "middle" }}>
                                            <div className="d-flex horizon-align-center">
                                              <div className="form-check form-switch" style={{ marginLeft: "0.5rem" }}>
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={contact.sendYn === "Y" ? true : false}
                                                  onClick={e => {
                                                    handleInput("sendYn", contactIdx, (e.target.checked ? "Y" : "N"));
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </td>
                                          <td style={{ verticalAlign: "middle" }}>
                                            <div className="d-flex horizon-align-center">
                                              <div className="form-check form-switch" style={{ marginLeft: "0.5rem" }}>
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={contact.hagueSendYn === "Y" ? true : false}
                                                  onClick={e => {
                                                    handleInput("hagueSendYn", contactIdx, (e.target.checked ? "Y" : "N"));
                                                    // console.log("send via Hague Notifier");
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </td>
                                          <td style={{ verticalAlign: "middle" }}>
                                            <div className="d-flex horizon-align-center">
                                              <div className="form-check form-switch" style={{ marginLeft: "0.5rem" }}>
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={contact.filerSendYn === "Y" ? true : false}
                                                  onClick={e => {
                                                    handleInput("filerSendYn", contactIdx, (e.target.checked ? "Y" : "N"));
                                                    //console.log("send via FR");
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </td>
                                          <td style={{ verticalAlign: "middle" }}>
                                            <div className="d-flex horizon-align-center">
                                              <div className="form-check form-switch" style={{ marginLeft: "0.5rem" }}>
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={contact.pctSendYn === "Y" ? true : false}
                                                  onClick={e => {
                                                    handleInput("pctSendYn", contactIdx, (e.target.checked ? "Y" : "N"));
                                                    // console.log("send via PCT Notifier");
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </td>
                                        </>
                                      }
                                      <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {contactIdx + 1 === contactsDetails.contactsList.length ?
                                          <Link to="#" onClick={(e) => {
                                              addContacts()
                                          }
                                          }>
                                            <i className="uil uil-plus-square font-size-22" id="addContacts"></i>
                                            <UncontrolledTooltip placement="top" target="addContacts" className="domain-correct-tooltip">
                                              Add more contacts
                                            </UncontrolledTooltip>
                                          </Link>
                                          : null}
                                      </td>
                                    </tr>
                                    {
                                      contact.unsubscribe === "D" && (
                                        <UncontrolledTooltip 
                                          placement="bottom" 
                                          target={`contact-${contactIdx}`} 
                                          className="unavailable-contact-tooltip"
                                          modifiers={[
                                            {
                                              name: "offset",
                                              options: {
                                                offset: [-288, 0],
                                              },
                                            },
                                          ]}
                                        >
                                          This email address is no longer valid for the entity according to our findings, and emails sent to it will not be delivered.
                                        </UncontrolledTooltip>
                                      )
                                    }
                                  </>
                                )
                              })
                              }
                            </tbody>
                          </Table>
                          : null}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            {memberConfirmedContacts.length > 0 ?
              <TabPane tabId="MemberConfirmedContacts">
                <Row>
                  <Col lg="12">
                    <Card>
                      <div className="p-4">
                        <Media className="d-flex align-items-center">
                          <div className="flex-grow-1 overflow-hidden">
                            <p className="text-muted mb-0">These are the contacts suggested by the representative firm.</p>
                          </div>
                        </Media>
                      </div>
                      <CardBody>
                        <CardTitle className="text-muted mb-0">
                          <Row className="mb-3">
                            <span className="button-items">
                              <Button type="button" color="primary" outline className="waves-effect waves-light"
                                onClick={() => {
                                    addAdress('memberConfirmedContacts', -1)
                                }}
                              >Add to contacts
                              </Button>
                            </span>
                          </Row>
                        </CardTitle>

                        <Table className="table mb-0">
                          <thead>
                            <tr>
                              <th style={{ verticalAlign: "middle", textAlign: "center" }}><input type="checkbox" checked={chkAllMemberConfirmedContacts} onClick={(e) => memberConfirmedContactsChk("chkAll", e)} /></th>
                              <th>Email address</th>
                              <th>First name</th>
                              <th>Last name</th>
                              <th>Title</th>
                              <th>Position</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {memberConfirmedContacts && memberConfirmedContacts.length ?
                              memberConfirmedContacts.map((contact, idx) => {
                                return (
                                  <tr className={contact.modFlag === "I" ? "bg-soft-danger" : null}>
                                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                      <input type="checkbox" className="form-check-input"
                                        id={"memberConfirmedContacts_" + idx}
                                        checked={contact.checked}
                                        onClick={(e) => memberConfirmedContactsChk(idx, e)} />
                                    </td>
                                    <td>{contact.scrapeType == 'Manual' ? <><i className="uil uil-lightbulb-alt font-size-18 text-success"></i>&nbsp;</> : null}{contact.emailAddress}</td>
                                    <td>{contact.firstName}</td>
                                    <td>{contact.lastName}</td>
                                    <td>{contact.title}</td>
                                    <td>{contact.position}</td>
                                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                      <Link to="#" onClick={(e) => {
                                          addAdress('memberConfirmedContacts', idx)
                                      }}>
                                        <i className="uil uil-user-plus font-size-22" id={"addMemberConfirmedContacts_" + idx}></i>
                                        <UncontrolledTooltip placement="top" target={"addMemberConfirmedContacts_" + idx} className="domain-correct-tooltip">
                                          Add to contacts
                                        </UncontrolledTooltip>
                                      </Link>
                                    </td>
                                  </tr>
                                )
                              })
                              : null
                            }
                          </tbody>
                        </Table>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
              : null}
            {memberConfirmedContacts.length === 0 ?
              <TabPane tabId="WeCrestSuggest">
                <Row>
                  <Col lg="12">
                    <Card>
                      <div className="p-4">
                        <Media className="d-flex align-items-center">
                          {/*
                          <div className="flex-shrink-0 me-3">
                            <i className="uil uil-envelope-info text-primary h2"></i>
                          </div>
                          */}
                          <div className="flex-grow-1 overflow-hidden">
                            {
                              contactsDetails?.unsubscribeYn == 'Y' 
                                ? <p className='text-danger mb-0'>This is an unsubscribed entity that has requested not to receive emails, and suggested contacts are therefore not available.</p> 
                                  : <p className="text-muted mb-0">These emails have been curated by WeCrest. These are not email addresses entered by you or any other WeCrest members. We very strictly do not share with anyone any of the data that you enter on our platform, unless explicitly authorized.</p>

                            }
                          </div>
                        </Media>
                      </div>
                      {
                        contactsDetails?.unsubscribeYn != 'Y' && (
                          <CardBody>
                            <CardTitle className="text-muted mb-0">
                              <Row className="mb-3">
                                <span className="button-items">
                                  <Button type="button" color="primary" outline className="waves-effect waves-light"
                                    onClick={() => {
                                      addAdress('suggest', -1)
                                    }}
                                  >Add to contacts
                                  </Button>
                                </span>
                              </Row>
                            </CardTitle>
                            <Row>
                              <div className="form-inline float-md-end">
                                <div className="search-box ml-2">
                                  <div className="position-relative">
                                    <Input type="text" className="orm-control bg-light border-light rounded" placeholder="Search..."
                                      onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                          searchSuggestedContacts(e.target.value);
                                        }
                                      }} />
                                    <i className="mdi mdi-magnify search-icon"></i>
                                  </div>
                                </div>
                              </div>
                            </Row>

                            <Table className="table mb-0">
                              <thead>
                                <tr>
                                  <th style={{ verticalAlign: "middle", textAlign: "center" }}><input type="checkbox" checked={chkAll2} onClick={(e) => suggestedContactsChk("chkAll", e)} /></th>
                                  <th>Email address</th>
                                  <th>First name</th>
                                  <th>Last name</th>
                                  <th>Title</th>
                                  <th>Position</th>
                                  <th>Country</th>
                                  <th>Office</th>
                                  <th>Field</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  contactsDetails &&
                                    (
                                      field == "Patent" ||
                                      (
                                        field != "Patent" &&
                                        contactsDetails?.domainCorrectYn &&
                                        contactsDetails?.domainCorrectYn === "Y" &&
                                        contactsDetails?.domain &&
                                        contactsDetails?.domain !== "NOT_SAME" &&
                                        contactsDetails?.domain !== "NOT_MAX"
                                      )

                                    ) &&
                                    suggestedContactsActive &&
                                    suggestedContactsActive.length ?
                                    suggestedContactsActive.map((contact, idx) => {
                                      return (
                                        <tr className={contact.modFlag === "I" ? "bg-soft-danger" : null}>
                                          <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                            <input type="checkbox" className="form-check-input"
                                              id={"suggestedContacts_" + idx}
                                              checked={contact.checked}
                                              onClick={(e) => suggestedContactsChk(idx, e)} />
                                          </td>
                                          <td>
                                            {
                                              contact.showBulb
                                                ? <>
                                                  <i className="uil uil-lightbulb-alt font-size-18 text-success">
                                                  </i>&nbsp;
                                                </>
                                                : suggestedContactsActive.filter(sug => sug.showBulb).length > 0
                                                  ? <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                                                  : <></>
                                            }
                                            {contact.emailAddress}</td>
                                          <td>{contact.firstName}</td>
                                          <td>{contact.lastName}</td>
                                          <td>{contact.title}</td>
                                          <td>{contact.position}</td>
                                          <td>
                                            <span id={"suggestedContactCountry_" + idx}>{contact.countryName}</span>
                                          </td>
                                          <td>{contact.office}</td>
                                          <td>{contact.ipType}</td>
                                          <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                            <Link to="#" onClick={(e) => {
                                              addAdress('suggest', idx)
                                            }}>
                                              <i className="uil uil-user-plus font-size-22" id={"addSuggestedAdress_" + idx}></i>
                                              <UncontrolledTooltip placement="top" target={"addSuggestedAdress_" + idx} className="domain-correct-tooltip">
                                                Add to contacts
                                              </UncontrolledTooltip>
                                            </Link>
                                          </td>
                                        </tr>
                                      )
                                    })
                                    : null
                                }
                              </tbody>
                            </Table>
                            <div className="d-flex justify-content-end">
                              <span className="d-flex align-items-center gap-2">
                                <div className="d-flex gap-1">
                                  <Button
                                    type="button"
                                    color="primary"
                                    onClick={() => { viewSuggestedContactsList(1); }}
                                    disabled={(suggestedCurPage == 1)}
                                  >
                                    {"<<"}
                                  </Button>
                                  <Button
                                    type="button"
                                    color="primary"
                                    onClick={() => { viewSuggestedContactsList(Math.max(suggestedCurPage - 1, 1)); }}
                                    disabled={(suggestedCurPage == 1)}
                                  >
                                    {"<"}
                                  </Button>
                                </div>
                                Page{" "}
                                <strong>
                                  {suggestedCurPage} of {suggestedTotalPage}
                                </strong>

                                <Input
                                  type="number"
                                  min={1}
                                  style={{ width: 70 }}
                                  max={suggestedTotalPage}
                                  name="curPage"
                                  defaultValue={suggestedCurPage}
                                  value={suggestedCurPageInput}
                                  onChange={(e) => { setSuggestedCurPageInput(e.target.value) }}
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                      viewSuggestedContactsList(e.target.value);
                                    }
                                  }}
                                />
                                <div className="d-flex gap-1">
                                  <Button
                                    type="button"
                                    color="primary"
                                    onClick={() => { viewSuggestedContactsList(Math.min(suggestedCurPage + 1, suggestedTotalPage)); }}
                                    disabled={(suggestedCurPage == suggestedTotalPage)}
                                  >
                                    {">"}
                                  </Button>
                                  <Button
                                    type="button"
                                    color="primary"
                                    onClick={() => { viewSuggestedContactsList(suggestedTotalPage); }}
                                    disabled={(suggestedCurPage == suggestedTotalPage)}
                                  >
                                    {">>"}
                                  </Button>
                                </div>
                              </span>
                            </div>
                          </CardBody>
                        )
                      }
                    </Card>
                  </Col>
                </Row>
              </TabPane>
              : null}
            <TabPane tabId="ImportedEmail">
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <CardTitle className="text-muted mb-0">
                        <Row className="mb-3">
                          <span className="button-items">
                            <Button type="button" color="primary" outline className="waves-effect waves-light"
                              onClick={() => {
                                  addAdress('imported', -1)
                              }}
                            >Add to contacts
                            </Button>
                          </span>
                        </Row>
                      </CardTitle>
                      <Row>
                        <div className="form-inline float-md-end">
                          <div className="search-box ml-2">
                            <div className="position-relative">
                              <Input type="text" className="orm-control bg-light border-light rounded" placeholder="Search..."
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter') {
                                    searchImportedContacts(e.target.value);
                                  }
                                }} />
                              <i className="mdi mdi-magnify search-icon"></i>
                            </div>
                          </div>
                        </div>
                      </Row>
                      {importedContacts && importedContacts.length ?
                        <>
                          <Table className="table mb-0">
                            <thead>
                              <tr>
                                <th style={{ verticalAlign: "middle", textAlign: "center" }}><input type="checkbox" checked={importedChkAll} onClick={(e) => importedContactsChk("chkAll", e)} /></th>
                                <th>Email address</th>
                                <th>First name</th>
                                <th>Last name</th>
                                <th>Title</th>
                                <th>Position</th>
                                <th>Country</th>
                                <th>Office</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {importedContacts.map((contact, idx) => {
                                return (
                                  <tr className={contact.modFlag === "I" ? "bg-soft-danger" : null}>
                                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                      <input type="checkbox" className="form-check-input"
                                        id={"importedContacts_" + idx}
                                        checked={contact.checked}
                                        onClick={(e) => importedContactsChk(idx, e)} />
                                    </td>
                                    <td>{contact.emailAddress}</td>
                                    <td>{contact.firstName}</td>
                                    <td>{contact.lastName}</td>
                                    <td>{contact.title}</td>
                                    <td>{contact.position}</td>
                                    <td>{contact.countryName}</td>
                                    <td>{contact.office}</td>
                                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                      <Link to="#" onClick={(e) => {
                                          addAdress('imported', idx)
                                      }}>
                                        <i className="uil uil-user-plus font-size-22" id={"addImportedAdress_" + idx}></i>
                                        <UncontrolledTooltip placement="top" target={"addImportedAdress_" + idx} className="domain-correct-tooltip">
                                          Add to contacts
                                        </UncontrolledTooltip>
                                      </Link>
                                    </td>
                                  </tr>
                                )
                              })
                              }
                            </tbody>
                          </Table>
                          <div className="d-flex justify-content-end">
                            <span className="d-flex align-items-center gap-2">
                              <div className="d-flex gap-1">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => { viewContactsListUp(1); }}
                                  disabled={(curPageUp == 1)}
                                >
                                  {"<<"}
                                </Button>
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => { viewContactsListUp(curPageUp - 1); }}
                                  disabled={(curPageUp == 1)}
                                >
                                  {"<"}
                                </Button>
                              </div>
                              Page{" "}
                              <strong>
                                {curPageUp} of {importedTotalPage}
                              </strong>

                              <Input
                                type="number"
                                min={1}
                                style={{ width: 70 }}
                                max={importedTotalPage}
                                name="curPage"
                                defaultValue={curPageUp}
                                value={curPageInput}
                                onChange={(e) => { setCurPageInput(e.target.value) }}
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter') {
                                    viewContactsListUp(e.target.value);
                                  }
                                }}
                              />
                              <div className="d-flex gap-1">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => { viewContactsListUp(curPageUp + 1); }}
                                  disabled={(curPageUp == importedTotalPage)}
                                >
                                  {">"}
                                </Button>
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => { viewContactsListUp(importedTotalPage); }}
                                  disabled={(curPageUp == importedTotalPage)}
                                >
                                  {">>"}
                                </Button>
                              </div>
                            </span>
                          </div>
                        </>
                        : null}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewDetail;